<template>
<div class="bg-header" style="font-family: Montserrat; color:white">
  <v-row>
    <v-col cols="2" class="mt-2">
      <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-col>
    <v-col cols="3">
      <div>
        <div class="text-center" style="font-size: 40px">
          Ajefech
        </div>
      </div>
    </v-col>
    <v-navigation-drawer
        v-model="drawer"
        temporary
      >
        <v-list density="compact" nav>
          <v-list-item title="Inicio" href="/"></v-list-item>
          <v-list-group value="Tournament">
        <template v-slot:activator="{ props }">
          <v-list-item
            v-bind="props"
            title="Torneos"
          ></v-list-item>
        </template>

        <v-list-item
            title="Proximos Torneos"
            href="/torneos/"
          ></v-list-item>
        <v-list-item
            title="Torneos Rankeados"
            href="/torneos_contabilizados/"
          ></v-list-item>
      </v-list-group>
          <v-list-group value="Players">
        <template v-slot:activator="{ props }">
          <v-list-item
            v-bind="props"
            title="Jugadores"
          ></v-list-item>
        </template>

        <v-list-item
            title="Listado"
            href="/jugadores/"
          ></v-list-item>
        <v-list-item
            title="Ranking"
            href="/ranking_jugadores/"
          ></v-list-item>
      </v-list-group>

      <v-list-group v-if="is_authenticated" value="Users">
        <template v-slot:activator="{ props }">
          <v-list-item
            v-bind="props"
            title="Administracion"
          ></v-list-item>
        </template>

        <v-list-item
            title="Mis Torneos"
            href="/mis_torneos/"
          ></v-list-item>
        <v-list-item
            title="Mis Articulos"
            href="/mis_articulos/"
          ></v-list-item>
        <v-list-item
            title="Clubes"
            href="/clubes/"
          ></v-list-item>
        <v-list-item
            title="Cambiar Contraseña"
            href="/cambiar_contraseña/"
          ></v-list-item>
        <v-list-item
            title="Salir"
            href="/logout/"
          ></v-list-item>

      </v-list-group>
          <v-list-group v-if="infos" value="infos">
        <template v-slot:activator="{ props }">
          <v-list-item
            v-bind="props"
            title="Organizacion"
          ></v-list-item>
        </template>
        <v-list-item v-for="rule in infos" :key="rule.id"
            :title="rule.title"
            :href="'/reglamento/'+rule.id"
          ></v-list-item>
      </v-list-group>
          <v-list-group v-if="rules" value="rules">
        <template v-slot:activator="{ props }">
          <v-list-item
            v-bind="props"
            title="Reglamentos"
          ></v-list-item>
        </template>
        <v-list-item v-for="rule in rules" :key="rule.id"
            :title="rule.title"
            :href="'/reglamento/'+rule.id"
          ></v-list-item>
      </v-list-group>
          <v-list-group value="Comunity">
        <template v-slot:activator="{ props }">
          <v-list-item
            v-bind="props"
            title="Comunidad"
          ></v-list-item>
        </template>

        <v-list-item
            title="Arbitros"
            href="/arbitros/"
          ></v-list-item>
        <v-list-item
            title="Entrenadores"
            href="/entrenadores/"
          ></v-list-item>
            <v-list-item
            title="Organizadores"
            href="/organizadores/"
          ></v-list-item>
            <v-list-item
            title="Administradores"
            href="/administradores/"
          ></v-list-item>
      </v-list-group>
        </v-list>
      </v-navigation-drawer>
  </v-row>

</div>


</template>

<script>
import {mapState} from "vuex";

export default {
  name: "MenuChess",

  data(){
    return {
      login:0,
      drawer: null,
      admins: [
        ['Management', '/mis_torneos/'],
        ['Settings', 'mdi-cog'],
      ],
    }
  },
  computed: {
    ...mapState(['is_authenticated', 'rules', 'infos']),
  }
}
</script>

<style>

</style>